<div class="login" data-testid="login-page">
  <div class="login-box">
    <div class="left"><img class="image-404" src="../img/LOGO.png" alt="Logo ACIN" /><br /></div>

    <div class="right">
      <form [formGroup]="loginForm" (ngSubmit)="onSubmit()">
        <h1>Costos Integrales</h1>
        <div class="form-grid">
          <mat-form-field appearance="outline" class="full-width">
            <mat-label>Usuario</mat-label>
            <input matInput type="text" placeholder="Usuario" formControlName="username" data-testid="login-username" />
            @if (loginForm.get('username')?.hasError('required')) {
              <mat-error class="for-text text-danger"> Campo obligatorio </mat-error>
            }
          </mat-form-field>

          <mat-form-field appearance="outline" class="full-width">
            <mat-label>Contraseña</mat-label>
            <input matInput type="password" placeholder="Contraseña" formControlName="password" data-testid="login-password" />
            @if (loginForm.get('password')?.hasError('required')) {
              <mat-error class="for-text text-danger"> Campo obligatorio </mat-error>
            }
          </mat-form-field>
        </div>

        <span class="error-message" data-testid="login-error">
          @if (errorMsg) {
            <div>
              {{ errorMsg }}
            </div>
          }
        </span>

        <button class="button-sesion" type="submit" data-testid="login-submit">Iniciar sesión</button>
        <div class="google-signin-container">
          <div #googleButton></div>
        </div>
      </form>
    </div>
  </div>
</div>
